<template>
  <section :style="decoration">
    <div style="margin-bottom: 58px;">
      <bl-text-av tag="h2" class="mb-16" variation="heading-42" weight="bold" align="center" color="inverse">
        {{ $options.videoList.title }}
      </bl-text-av>

      <bl-text-av align="center" color="inverse" style="font-size: 26px; line-height: 32px;">
        {{ $options.videoList.subtitle }}
      </bl-text-av>
    </div>

    <div v-if="mutualFundVideos" class="pv-24 ph-16">
      <bl-flex-container-mv align-items="center" justify-content="center">
        <bl-flex-item-av>
          <client-only>
            <div
              class="u-txt--center video-cover"
              style="position: relative; width: 760px; height: 449px; margin-bottom: 28px"
              @click="openVideoPopup"
            >
              <img :src="videoImage" style="width: 100%; height: 100%; border-radius: 8px" />
              <div class="play-button">
                <div style="position: relative; width: 100%; height: 100%">
                  <ico-play class="play-button__icon" color="#fff" />
                </div>
              </div>
            </div>
          </client-only>

          <bl-text-av variation="heading-28" weight="bold">
            Cara Mudah & berkah Berinvestasi Syariah di BukaReksa
          </bl-text-av>
        </bl-flex-item-av>
      </bl-flex-container-mv>

      <template v-if="showVideoPopup">
        <div class="video-popup-bg" />
        <div class="video-popup-wrap">
          <div class="video-popup-container">
            <div class="video-popup-content">
              <bl-button-av
                variation="primary"
                class="close-button"
                ico-name="ico_cross_minor"
                @click.native="closeVideoPopup"
              />
              <youtube :video-id="videoId" :height="506.25" :width="900" />
            </div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
/* istanbul ignore file */
import { assetURL } from 'shared/helpers/assetHelper';
import { VideoList as videoList } from 'shared/modules/seo/Homepage';
import BlTextAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlTextAv';
import BlButtonAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlButtonAv';
import ClientOnly from 'vue-client-only';
import BlFlexContainerMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlFlexItemAv';
import IcoPlay from '@bukalapak/bazaar-visual-next/dist/components/IcoPlay';
import { getIdFromURL } from 'vue-youtube-embed';

export default {
  name: 'VideoList',

  videoList,

  components: {
    BlTextAv,
    ClientOnly,
    IcoPlay,
    BlButtonAv,
    BlFlexContainerMv,
    BlFlexItemAv,
  },

  data() {
    return {
      showVideoPopup: false,
    };
  },

  computed: {
    mutualFundVideos() {
      return this.$store.state.server.mutualFundVideos;
    },

    videoId() {
      return (this.mutualFundVideos && getIdFromURL(this.mutualFundVideos.url)) || '';
    },

    isSSR() {
      return this.$root.isSSR;
    },

    videoImage() {
      return assetURL('bukareksa-video-thumb.jpg', this.isSSR);
    },

    decoration() {
      return {
        'background-repeat': 'no-repeat',
        'background-position': 'top center',
        'background-image': `url(${assetURL('video_list_decoration_desktop.png', this.isSSR)})`,
        'background-size': '100%',
        padding: '60px 0',
      };
    },
  },

  created() {
    if (!this.$root.isSSR && !this.mutualFundVideos) {
      // Ignore error because
      this.$store.dispatch('server/retrieveMutualFundVideos');
    }
  },

  methods: {
    openVideoPopup() {
      this.showVideoPopup = true;
    },
    closeVideoPopup() {
      this.showVideoPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 111px;
  height: 75px;
  background: #3d3d3d;
  border-radius: 18px;
  opacity: 0.7;
  transform: translate(-50%, -50%);

  &__icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.video-cover {
  cursor: pointer;
  overflow: hidden;

  &:hover {
    .play-button {
      opacity: 1;
    }
  }
}

.video-popup {
  &-bg {
    opacity: 0.8;
    background: #0b0b0b;
    position: fixed;
    overflow: hidden;
    z-index: 1042;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
  }

  &-wrap {
    position: fixed;
    outline: none;
    z-index: 1043;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
  }

  &-container {
    text-align: center;
    padding: 0.57143rem;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    box-sizing: border-box;
    position: absolute;
    z-index: 1044;
  }

  &-content {
    z-index: 1045;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.close-button {
  border-radius: 50%;
  opacity: 1;
  cursor: pointer;
  overflow: visible;
  border: 0;
  z-index: 1046;
  width: 24px !important;
  height: 24px !important;
  position: absolute;
  right: -12px;
  top: -28px;
}
</style>
